export default __webpack_public_path__ + "static/media/load.9301e5f6.svg";